module.exports = __webpack_public_path__ + "img/schedule.4a614a85.svg";